import React from 'react'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom/client'
import { PersistGate } from 'redux-persist/integration/react'
import { HelmetProvider } from 'react-helmet-async'

import reportWebVitals from './reportWebVitals'
import { persistor, store } from '@/stores'
import App from './App'

import '@/assets/scss/reset.scss'
import '@/assets/scss/common.css'

const CHUNK_RELOAD_GUARD_KEY = 'chunkReloadAt'
const CHUNK_RELOAD_GUARD_MS = 10_000

const isChunkLoadError = (err: any): boolean => {
  if (!err) {
    return false
  }
  if (err.name === 'ChunkLoadError') {
    return true
  }
  return /Loading (CSS )?chunk \S+ failed/i.test(String(err.message ?? ''))
}

const reloadOnChunkError = (err: any) => {
  if (!isChunkLoadError(err)) {
    return
  }
  const now = Date.now()
  const last = Number(sessionStorage.getItem(CHUNK_RELOAD_GUARD_KEY) ?? 0)
  if (now - last < CHUNK_RELOAD_GUARD_MS) {
    return
  }
  sessionStorage.setItem(CHUNK_RELOAD_GUARD_KEY, String(now))
  window.location.reload()
}

window.addEventListener('error', (e) => reloadOnChunkError(e.error))
window.addEventListener('unhandledrejection', (e) => reloadOnChunkError(e.reason))

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
